import type { ConsumableRecord, ProductComponentRecord } from '../types/records'

/** Имя категории расходников, строки которой в спецификации считаются работой (цена × кол-во). */
export const LABOR_CATEGORY_NAME = 'Работа'

export function isLaborConsumable(c?: ConsumableRecord | null): boolean {
  if (!c) return false
  if (c.unit === 'labor') return true
  const n = c.expand?.consumable_category?.name
  return typeof n === 'string' && n.trim() === LABOR_CATEGORY_NAME
}

export function lineCost(qty: number, pricePerUnit: number): number {
  const q = Number(qty) || 0
  const p = Number(pricePerUnit) || 0
  return Math.round(q * p * 100) / 100
}

export type BomBreakdown = {
  materials: number
  labor: number
  total: number
  /** Есть хотя бы одна строка с расходником из категории «Работа» */
  hasLabor: boolean
}

export function bomBreakdown(
  lines: { quantity: number; consumable?: ConsumableRecord | null }[],
): BomBreakdown {
  let materials = 0
  let labor = 0
  let hasLabor = false
  for (const l of lines) {
    const price = l.consumable != null ? Number(l.consumable.price) || 0 : 0
    const part = lineCost(l.quantity, price)
    if (isLaborConsumable(l.consumable)) {
      labor += part
      hasLabor = true
    } else {
      materials += part
    }
  }
  materials = Math.round(materials * 100) / 100
  labor = Math.round(labor * 100) / 100
  return {
    materials,
    labor,
    total: Math.round((materials + labor) * 100) / 100,
    hasLabor,
  }
}

export function bomTotal(
  lines: { quantity: number; consumable?: ConsumableRecord | null }[],
): number {
  return bomBreakdown(lines).total
}

export function bomBreakdownFromComponents(rows: ProductComponentRecord[]): BomBreakdown {
  return bomBreakdown(
    rows.map((r) => ({
      quantity: Number(r.quantity) || 0,
      consumable: r.expand?.consumable ?? null,
    })),
  )
}

export function bomFromComponents(rows: ProductComponentRecord[]): number {
  return bomBreakdownFromComponents(rows).total
}
